import * as R from 'ramda'
import type { ReturnItem } from '@hooks/useReturnOrders'
import type { EcwOrderPayment } from '@model/ecw/EcwOrder'
import type { ReturnOrderItem } from '@components/support/Returns/OrderDetails'

const isRefund = R.propEq('actionValue', 'REFUND')
const isDiscount = R.propEq('actionValue', 'DISCOUNT')
const isReplaceAction = R.propEq('actionValue', 'REPLACE')
const isGuaranteeAction = R.propEq('actionValue', 'GUARANTEE')
const isEmptyAction = R.propEq('actionValue', '')
const isEmptyReason = R.propEq('reasonValue', '')

const isAdyen = R.propEq('paymentMethod', 'adyen')
const isKlarna = R.propEq('paymentMethod', 'klarna')

const isRefundable = R.anyPass([isRefund, isDiscount])
const isReplace = R.anyPass([isReplaceAction, isGuaranteeAction])
const isEmptySelection = R.anyPass([isEmptyAction, isEmptyReason])

export const isThereAnyRefundAndDiscountItems = R.any<ReturnItem | ReturnOrderItem>(isRefundable)
export const isThereAnyReplaceItems = R.any<ReturnItem>(isReplace)
export const isThereAnyEmptyActionsOrReasons = R.any<ReturnItem>(isEmptySelection)

const isAdyenOrKlarnaPayment = R.anyPass([isAdyen, isKlarna])
export const isAutomaticallyRefundable = R.any<EcwOrderPayment>(isAdyenOrKlarnaPayment)
